module.exports = __webpack_public_path__ + "img/floatright1.5c5240b5.jpg";